module.exports = __webpack_public_path__ + "media/images/edit-pen-313e5d42abcea0e90e1d60826ad95e3a.png";